import { inject } from "@angular/core";
import { Router, type CanActivateFn, type UrlTree } from "@angular/router";

import { AuthStateService } from "../services/auth-state.service";

/**
 * Hides the Davaco-only areas from customer users.
 *
 * A route guard is a UI affordance, not a security boundary — every admin
 * endpoint re-checks the role server-side against the verified token.
 */
export const davacoAdminGuard: CanActivateFn = (): boolean | UrlTree => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  return authState.isDavacoAdmin() ? true : router.createUrlTree(["/forbidden"]);
};
